const ITEMS = [
  "Precision Engineering",
  "Pharmaceutical Cleanroom Equipment",
  "SS 304 Stainless Steel",
  "HEPA-Filtered Airflow Systems",
  "Custom Sheet Metal Fabrication",
  "Smart / IoT-Enabled Equipment",
  "Application-Driven Design",
  "Made in India for Global Markets",
];

export default function Marquee({ dark = false }) {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className={`overflow-hidden border-y py-3.5 ${dark ? "border-white/5 bg-[#0a1420]" : "border-line bg-mist"}`}
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className={`flex items-center font-mono text-[11px] uppercase tracking-[0.28em] ${dark ? "text-slate-500" : "text-steel"}`}>
                <span className="px-6">{item}</span>
                <span className="text-accent">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
